import { useForm } from "@kanda-libs/ks-component-ts";
import { UserType } from "@kanda-libs/ks-frontend-services";
import type { StringIndexedObject } from "@kanda-libs/ks-design-library";
import type { UseFormReturn } from "react-hook-form";
import { formatDefaultValues, formatDirectorAddress } from "./helpers";

export type DirectorInfoFormValues = UserType;

export interface DirectorInfoFormHook {
  form: UseFormReturn<DirectorInfoFormValues>;
  onSubmit: (formValues: StringIndexedObject) => void;
}

export default function useDirectorInfoForm(
  index: number,
  user: UserType | undefined,
  onEdit: (index: number, director: UserType) => void
): DirectorInfoFormHook {
  const form = useForm<DirectorInfoFormValues>({
    defaultValues: formatDefaultValues(user),
  });

  const onSubmit = (formValues: StringIndexedObject) => {
    onEdit(index, {
      ...formValues,
      director_info: {
        ...formValues.director_info,
        date_of_birth: formValues.director_info.date_of_birth
          ? formValues.director_info.date_of_birth
              .split("/")
              .reverse()
              .join("-")
          : undefined,
        home_address: formatDirectorAddress(
          formValues.director_info.home_address
        ),
      },
    } as UserType);
  };

  return {
    form,
    onSubmit,
  };
}
